import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

export const FaqSection = ({ faqs, language = 'de', title, className = '' }) => {
    if (!faqs || faqs.length === 0) return null;
    const schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        inLanguage: language,
        mainEntity: faqs.map((f) => ({
            '@type': 'Question',
            name: f.q,
            acceptedAnswer: { '@type': 'Answer', text: f.a },
        })),
    };
    return (
        <section className={`max-w-3xl mx-auto ${className}`} data-testid="faq-section">
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
            <h2 className="font-display text-2xl md:text-3xl font-bold mb-6 text-center">
                {title || (language === 'de' ? 'Häufige Fragen' : 'Frequently Asked Questions')}
            </h2>
            <Accordion type="single" collapsible className="w-full">
                {faqs.map((f, i) => (
                    <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
                        <AccordionTrigger className="text-left text-sm md:text-base font-semibold" data-testid={`faq-question-${i}`}>
                            {f.q}
                        </AccordionTrigger>
                        <AccordionContent className="text-sm text-muted-foreground leading-relaxed" data-testid={`faq-answer-${i}`}>
                            {f.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </section>
    );
};
